// addInsertValuesRow — VQE-Edit edit-action: append a VALUES row to an
// `INSERT INTO t (cols…) VALUES (…)` statement via SR-Edit's
// `add-insert-values-row` op. SR-Edit handles the comma + parens; this module
// only validates the value list and delegates to `commitEdit`.
//
// PRD: Ralph/VisualQueryEditorEdit/PRD.md § Slice: Edit — DML edits.

import { commitEdit, type CommitEditCtx } from '../commitEdit';

export async function addInsertValuesRow(
  values: readonly string[],
  ctx: CommitEditCtx,
): Promise<void> {
  if (values.length === 0) {
    throw new Error('addInsertValuesRow: values must contain at least one entry');
  }
  const cleaned = values.map((v, idx) => {
    const trimmed = v.trim();
    if (trimmed.length === 0) {
      throw new Error(
        `addInsertValuesRow: value at index ${idx} must not be empty`,
      );
    }
    return trimmed;
  });
  await commitEdit({ op: 'add-insert-values-row', values: cleaned }, ctx);
}
